// Partner/onboardingConstants.ts
import defaultLogo from "../../Assets/betterRefundsLogo.png";
import lianlianLogo from "../../Assets/IntegratedLogo.png";

export const ONBOARDING_VARIANT = {
  DEFAULT: "default",
  LIANLIAN: "lianlian",
} as const;

export type OnboardingVariant =
  typeof ONBOARDING_VARIANT[keyof typeof ONBOARDING_VARIANT];

export type DefaultOnboardingConfig = {};

export type LianLianOnboardingConfig = {
  productName: string;
  coBrandingText: string;
};

export type OnboardingConfigByVariant = {
  [ONBOARDING_VARIANT.DEFAULT]: DefaultOnboardingConfig;
  [ONBOARDING_VARIANT.LIANLIAN]: LianLianOnboardingConfig;
};

export type OnboardingConfig =
  OnboardingConfigByVariant[OnboardingVariant];

export const PARTNER_LOGO_MAP: Record<OnboardingVariant, string> = {
  [ONBOARDING_VARIANT.LIANLIAN]: lianlianLogo,
  [ONBOARDING_VARIANT.DEFAULT]: defaultLogo,
};